/**
 * 作品状态定义和同步
 * @author chenqunfeng
 * @since 17/11/03
 */

import { SET_USER_INFO } from '../constants/action.json5';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};
